// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inviteList_root__3qVIR {\n  height: calc(100% - 96px);\n  overflow: hidden; }\n  .inviteList_root__3qVIR .inviteList_loadingContainer__2ykBK {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n", ""]);
// Exports
exports.locals = {
	"root": "inviteList_root__3qVIR",
	"loadingContainer": "inviteList_loadingContainer__2ykBK"
};
module.exports = exports;
